import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../../routes';
import PSLoginContainer from '../../components/PSLoginContainer';

import './index.scss';

// const responseMessages = {
//   8000: 'Todas las operaciones se ejecutaron correctamente',
//   70006: 'HIT, persona identificada',
//   70007: 'No HIT, no es posible identificar a la persona',
//   401: 'Posible rostro falso',
//   9116: 'Se superó el tiempo de espera',
//   9117: 'Se produjo un error en el servicio de prueba de vida',
//   9041: 'El DNI está bloqueado por superar el máximo número de intentos',
//   8590: 'El DNI se encuentra caducado',
//   8383: 'Documento capturado inválido',
//   8270: 'La solicitud se encuentra bloqueada',
// };

const extractCode = (raw) => {
  const code = raw.split(':')[0].trim();
  const message = raw.split(':').length >= 2 ? raw.split(':')[1].trim() : '5000';
  return { code, message };
};

export default function BmoIframe({ iframeUrl, onClose }) {
  const iframeRef = useRef(null);
  const history = useHistory();

  const onMessage = ({ data }) => {
    if (typeof data === 'string') {
      const { code, message } = extractCode(data);
      if (
        data &&
        code === '8000' &&
        message === 'Todas las operaciones se efectuaron correctamente'
      ) {
        history.push({
          pathname: Routes.SIGN_UP_VALIDATION,
          // state: { idValidation: id },
        });
      }
    }

    // Ignore message from other sources
    if (data.zyName !== 'BMO-ZYTRUST' || !data.zyResponse) {
      return;
    }
    if (typeof data.zyResponse === 'string') {
      // Process the received message end
    } else if (typeof data.zyResponse === 'object') {
      // Process the received message partial
      console.log('mensaje Iframe + partial', data);
    }
  };

  useEffect(() => {
    window.addEventListener('message', onMessage);

    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, []);

  return (
    <PSLoginContainer className="user-container bioIframe" onClose={onClose}>
      <div
        style={{
          background: '#f9fafb',
          padding: '2rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <iframe
          id="bmoIframe"
          ref={iframeRef}
          src={iframeUrl}
          allow="camera; microphone"
          style={{
            border: '1px solid #d1d5db',
            borderRadius: '8px',
            width: '343px',
            height: '469px',
            background: '#fff',
          }}
          title="Validacion Facial"
        />
      </div>
    </PSLoginContainer>
  );
}
